import React, { useReducer, useEffect, useContext } from "react";
import {
  Col,
  Row,
  Accordion,
  Image,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import {
  dashboardInitialState,
  dashboardReducer,
} from "../../modules/activities/reducers/dashboardReducer";
import axiosInstance from "../../../config/axios";
import { FullPageOverlay } from "../loading/FullPageOverlay";
import { AuthContext } from "../../../contexts/AuthContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
function QuickTabs({ view, setView }) {
  const [detailsState, detailsDispatch] = useReducer(
    dashboardReducer,
    dashboardInitialState
  );
  const navigate = useNavigate();

  const handleClick = (guest, kid, id) => {

    navigate(`/activity-registrations/${id}`);

  };
  const handleNavigate = (url) => {

    navigate(url);

  };
  const { userAuthState } = useContext(AuthContext);
  const loadItem = async () => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });
    try {
      const res = await axiosInstance.get(
        `general/mobile-view-dashboard-stats`
      );
      detailsDispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  };
  useEffect(() => {
    loadItem();
  }, []);

  return (
    <>
      {detailsState.isFetching == true && <FullPageOverlay />}
      {detailsState.data && (
        <>
          <Card className="mt-2 mb-0 border-themePrimary">
            <Card.Body className="p-0">
              <Row className="mt-xl-3 mt-lg-3 mt-md-3 mt-1 px-1 ">
                <Col xl={4} lg={6} md={6} sm={6} xs={6} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=SignupRequest")}>
                  <a

                    className="d-flex h-100 w-100"
                  >
                    <div class="dashboard-box bg-linear-primary">
                      <div>
                        <h5 class="dashboard-box-heading">
                          Manage Membership Requests
                        </h5>
                      </div>
                      <div class="dashboard-box-icon">
                        <i class="fa fa-user-plus"></i>
                      </div>
                      <div>
                        <h5 class="dashboard-box-text d-flex flex-column">
                          {" "}
                          {detailsState.data.signupRequests === 0 ||
                            detailsState.data.signupRequests === "0" ? (
                            "No Pending Requests"
                          ) : (
                            <>
                              <strong className="fs-3">
                                {detailsState.data.signupRequests}
                              </strong>{" "}
                              Signup Request(s)
                            </>
                          )}
                        </h5>
                        {detailsState.data.signupRequests > 0 &&
                          <p className="mb-0 text-white fontBoldItalic fs-12 text-center heartbeat">Admin Action Required</p>}
                      </div>
                    </div>
                  </a>
                </Col>
                <Col xl={4} lg={6} md={6} sm={6} xs={6} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/chat?sort=unread")}>
                  <a className="d-flex h-100 w-100">
                    <div class="dashboard-box  bg-linear-secondary">
                      <div>
                        <h5 class="dashboard-box-heading">Manage Messages</h5>
                      </div>
                      <div class="dashboard-box-icon">
                        <i class="fa fa-comments"></i>
                      </div>
                      <div>
                        <h5 class="dashboard-box-text d-flex flex-column">
                          {" "}
                          {detailsState.data.unreadMessages === 0 ||
                            detailsState.data.unreadMessages === "0" ? (
                            "No Unread Message(s)"
                          ) : (
                            <>
                              <strong className="fs-3">
                                {detailsState.data.unreadMessages}
                              </strong>{" "}
                              Unread Message(s)
                            </>
                          )}
                        </h5>
                      </div>
                    </div>
                  </a>
                </Col>
                <Col xl={4} lg={6} md={6} sm={6} xs={6} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/activities?pastActivity=0")}>
                  <a

                    className="d-flex h-100 w-100"
                  >
                    <div class="dashboard-box  bg-linear-primary">
                      <div>
                        <h5 class="dashboard-box-heading">Manage Activities</h5>
                      </div>
                      <div class="dashboard-box-icon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <div>
                        <h5 class="dashboard-box-text d-flex flex-column">
                          {" "}
                          {detailsState.data.upcomingActivities === 0 ||
                            detailsState.data.upcomingActivities === "0" ? (
                            "No Upcoming Activities"
                          ) : (
                            <>
                              <strong className="fs-3">
                                {detailsState.data.upcomingActivities}
                              </strong>{" "}
                              Upcoming Activity(s)
                            </>
                          )}
                        </h5>
                      </div>
                    </div>
                  </a>
                </Col>
                <Col xl={4} lg={6} md={6} sm={6} xs={6} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/circles")}>
                  <a className="d-flex h-100 w-100">
                    <div class="dashboard-box  bg-linear-secondary">
                      <div>
                        <h5 class="dashboard-box-heading">Manage Circles</h5>
                      </div>
                      <div class="dashboard-box-icon">
                        <i class="fa fa-users"></i>
                      </div>
                    </div>
                  </a>
                </Col>

                <Col xl={4} lg={6} md={6} sm={6} xs={6} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/contact-us")}>
                  <a className="d-flex h-100 w-100">
                    <div class="dashboard-box bg-linear-primary">
                      <div>
                        <h5 class="dashboard-box-heading">Contact Us </h5>
                      </div>
                      <div class="dashboard-box-icon">
                        <i class="fa fa-users"></i>
                      </div>
                      <div>
                        <h5 class="dashboard-box-text d-flex flex-column">
                          {" "}
                          {detailsState.data.contactUsSubmissionsCount === 0 ||
                            detailsState.data.contactUsSubmissionsCount ===
                            "0" ? (
                            "No Submissions"
                          ) : (
                            <>
                              <strong className="fs-3">
                                {detailsState.data.contactUsSubmissionsCount}
                              </strong>{" "}
                              Submission(s)
                            </>
                          )}
                        </h5>
                      </div>
                    </div>
                  </a>
                </Col>
                {(userAuthState.user.role === "Admin" ||
                  userAuthState.user.role === "Club Vice President" ||
                  userAuthState.user.role === "Club President") && (
                    <Col xl={4} lg={6} md={6} sm={6} xs={6} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/payments?status=0")}>
                      <a className="d-flex h-100 w-100">
                        <div class="dashboard-box  bg-linear-secondary">
                          <div>
                            <h5 class="dashboard-box-heading">Manage Payments</h5>
                          </div>
                          <div class="dashboard-box-icon">
                            <i class="fa fa-dollar-sign"></i>
                          </div>
                          <div>
                            <h5 class="dashboard-box-text d-flex flex-column">
                              {" "}
                              {detailsState.data.pendingPayments === 0 ||
                                detailsState.data.pendingPayments === "0" ? (
                                "No Pending Payments"
                              ) : (
                                <>
                                  <strong className="fs-3">
                                    {detailsState.data.pendingPayments}
                                  </strong>{" "}
                                  Pending Payment(s)
                                </>
                              )}
                            </h5>
                          </div>
                        </div>
                      </a>
                    </Col>
                  )}
                {detailsState.data.activities && detailsState.data.activities.length > 0 &&
                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Card className="mb-2 bg-linear-primary">
                      <Card.Body className="pb-0">
                        <div className="d-flex align-items-start justify-content-between">
                          <div>
                            <h5 className=" text-white fs-9 mb-3 ">Registration Summary</h5>
                            {/* <p className="mb-0 text-white fontBoldItalic fs-12 text-left heartbeat hide  mb-0">Admin Action Required</p> */}
                          </div>
                          <div>
                            <Link to={"/activities"} className="btn btn-xs btn-light fontItalic"> View More</Link>
                          </div>

                        </div>

                        <div className="overflow-x-auto mt-0">

                          <table className="table-auto w-100 mt-6 border-collapse">
                            <thead className="">
                              <th className="text-white fontItalic font-weight-normal py-1">Activity</th>
                              <th className="text-white text-center fontItalic font-weight-normal py-1">Admin Approval pending</th>
                              <th className="text-white text-right fontItalic font-weight-normal py-1">Registrations</th>

                            </thead>

                            <tbody>
                              {detailsState.data.activities.map((item, index) => {
                                return (
                                  <tr onClick={() => handleClick(item.stats.guestsAdminApprovalPending, item.stats.kidsAdminApprovalPending, item._id)}
                                    className={"cursor-pointer animate cursor-pointer border-top border-bottom "}
                                    title={item.stats.guestsAdminApprovalPending > 0 || item.stats.kidsAdminApprovalPending > 0 ? "Click to Approve/Reject Request" : "View details"}>
                                    <td className="px-1 py-1 flex items-center gap-2">

                                      <span className="fontBoldItalic text-white">{item.title}</span>
                                      <p className="mb-2 fontItalic fs-12 text-white">{item.date}, {item.location}</p>
                                    </td>

                                    <td className="px-1 py-1 " >

                                      <div className="d-flex align-items-center justify-content-center text-white mt-1">

                                        <div className={`holder dashboard`}>
                                          <p className="title text-white ">Guests: </p>
                                          <p className="value text-white ms-2 "> {item.stats.guestsAdminApprovalPending}</p>
                                        </div>
                                        <div className={`holder text-white border-0`}>
                                          <p className="title text-white ">Kids: </p>
                                          <p className="value ms-2 text-white"> {item.stats.kidsAdminApprovalPending}</p>
                                        </div>
                                      </div>
                                      {item.stats.guestsAdminApprovalPending > 0 || item.stats.kidsAdminApprovalPending > 0 &&
                                        <p className="mb-0 text-white fontBoldItalic fs-12 text-center heartbeat  mb-0">Admin Action Required</p>}
                                    </td>
                                    <td className="px-1 py-1 ">
                                      <div className="d-flex align-items-center justify-content-end text-white mt-1">

                                        <div className={`holder dashboard border-0`}>
                                          <p className="title text-white ">Total Registrations: </p>
                                          <p className="value text-white ms-2 ">{item.stats.totalUniqueRequests}</p>
                                        </div>

                                      </div>

                                      
                                      {/* <div className="d-flex align-items-center justify-content-end text-white mt-1">

                                        <div className={`holder dashboard`}>
                                          <p className="title text-white ">Confirmed: </p>
                                          <p className="value text-white ms-2 ">{item.stats.totalConfirmedParticipants}</p>
                                        </div>
                                        <div className={`holder text-white border-0`}>
                                          <p className="title text-white ">Not Confirmed: </p>
                                          <p className="value ms-2 text-white">{item.stats.totalNotConfirmedParticipants}</p>
                                        </div>
                                      </div> */}

                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>}
              </Row>

              {view === false && (
                <>
                  <Row className=" my-xl-0 my-lg-0 my-md-0 my-2 p-xl-0 px-lg-0 px-md-0 px-1">
                    <Col>
                      <Button
                        variant="primary"
                        className="float-end"
                        size="sm"
                        onClick={() => setView(true)}
                      >
                        View More
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>
          </Card>
        </>
      )}
    </>
  );
}

export default QuickTabs;
